import { KnownProjectTeamMembershipDtoAccessLevel } from '@groundfloor-platform/mgmt-service-g-sdk';
import { FormControlLabel, Radio } from '@mui/material';
import { teamMembershipAccessLevelStrings } from '../details/logic/team-member-details.constants';

export interface AccessOptionProps {
  level: KnownProjectTeamMembershipDtoAccessLevel;
  /** Worded for this project — see `useAccessLevelDescriptions`. */
  description: string;
  classes: { RadioContainer: string; Radio: string };
}

/** One access level in the Access Level radio group, shared by inviting and editing a team member. */
export const AccessOption = ({ level, description, classes }: AccessOptionProps) => {
  return (
    <FormControlLabel
      className={classes.RadioContainer}
      value={level}
      control={<Radio className={classes.Radio} />}
      label={
        <>
          <strong>{teamMembershipAccessLevelStrings[level]}:</strong> {description}
        </>
      }
    />
  );
};
